import profileImage from './profileImage.png'
import contact1 from './contact1.jpeg'
import contact2 from './contact2.jpeg'
import contact3 from './contact3.jpeg'
import MyprofileImage from './MyprofileImage.png'
import myProfilePhoto from './myProfilePhoto.png'
import profilephoto from './profilephoto.png'
import skillup from './skillup.png'

export const assets ={
    profileImage, contact1, contact2, contact3, MyprofileImage, myProfilePhoto,profilephoto
}

export const projectData = [
    {
        _id: 1,
        title: "chat-app",
        name: "Media App",
        image: contact2,
        about: "Social media web app built with JavaScript",
        link: "https://media-web-zeta.vercel.app/"
    },
    {
        _id: 2,
        title: "ecommerce",
        name: "E-commerce",
        image: contact3,
        about: "E-commerce web app built with Reacjs",
        link: "https://e-commerce-web-ecru-five.vercel.app/"
    },
    {
        _id: 3,
        title: "ecommerce",
        name: "E-commerce website",
        image: contact1,
        about: "Advanced e-commerced website built with Reactjs",
        link: "https://estore-pied-theta.vercel.app/"
    },
    // {
    //     _id: 4,
    //     title: "chat-app",
    //     name: "skillUp",
    //     image: skillup,
    //     about: "A unique platform that connects mentors and learners of diverse fields.",
    //     link: "https://skill-up-phi.vercel.app/"
    // }
]